module.exports = __webpack_public_path__ + "static/img/2.1112c0a8.jpg";